import { createConsoleUrl } from '../utils/console';
import { Loader } from '../components/loader';

export const Welcome = () => {
  // TODO: Use redirectDocument from react-router@6.15
  window.location.replace(createConsoleUrl('welcome'));
  return <Loader />;
};
